// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useEffect, useState } from "react";
import { IoAlertOutline } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import GeneralButton from "../buttons/GeneralButton";
import { useSelector, useDispatch } from "react-redux";
import { addTimerPopUp } from "../../store/auth/action";
const TimerPopup = () => {
  const { timerPopup } = useSelector((state) => ({
    timerPopup: state.timerPopup,
  }));
  const dispatch = useDispatch();
  const [visibility, setVisibility] = useState("absolute");

  const handleClose = () => {
    setVisibility("hidden");
    dispatch(addTimerPopUp(null));
  };

  ///// custom loader starts
  const [count, setCount] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  useEffect(() => {
    if (count >= 10.5) {
      setVisibility("hidden");
    }
  }, [count]);
  useEffect(() => {
    let intervalId;

    if (isRunning) {
      intervalId = setInterval(() => {
        setCount((prevCount) => (prevCount >= 11 ? 11 : prevCount + 0.01));
      }, 10);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isRunning]);

  const pauseTimer = () => {
    setIsRunning(false);
  };

  const resumeTimer = () => {
    setIsRunning(true);
  };

  const resetTimer = () => {
    setCount(1);
  };
  /// custom loader ends
  return (
    <>
      {timerPopup ? (
        Object.keys(timerPopup).length ? (
          <div
            className={`${visibility} z-40 w-screen h-screen left-0 right-0 top-0 bottom-0 bg-[#00000080] flex justify-center items-center`}
          >
            <div
              onMouseOver={() => {
                pauseTimer();
              }}
              onMouseEnter={() => {
                pauseTimer();
              }}
              onMouseLeave={() => {
                resumeTimer();
              }}
              className="relative bg-[white] px-8 py-6 flex flex-col w-[516px] h-max gap-4"
            >
              <div className="absolute overflow-hidden top-0 left-0 w-full h-max text-xl flex justify-center bg-[#ffffff00]">
                <span
                  className="flex transition-all ease-linear duration-500 bg-[#5C276E] w-full h-1"
                  style={{
                    transform: `translateX(-${100 - (count * 100) / 10}%)`,
                  }}
                ></span>
              </div>
              <div className="flex flex-row justify-between items-center pb-2 pt-1 border-b border-[#E9E8E8]">
                <div className="flex flex-row items-center gap-2">
                  <IoAlertOutline className="hidden" size={24} />
                  <div className="text-xl font-semibold">
                    {timerPopup?.heading}
                  </div>
                </div>
                <RxCross1
                  className="cursor-pointer"
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>
              <div className="text-left w-full min-h-[56px] flex flex-col gap-4">
                {timerPopup?.content?.map((item, index) => (
                  <div key={index} className="w-full flex flex-col gap-1">
                    <div className="text-sm font-semibold">{item?.title}</div>
                    <div className="text-sm">{item?.paragraph}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-row justify-end pt-2 border-t border-[#E9E8E8]">
                <GeneralButton
                  text={timerPopup?.buttonText}
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(TimerPopup);
